import type { QueryClient } from "@tanstack/react-query"
import { voiceKeys } from "./keys"
import type { VoiceMessage } from "./types"

export function applyVoiceMessage(
	queryClient: QueryClient,
	friendId: number,
	newData: VoiceMessage,
): void {
	queryClient.setQueryData(voiceKeys.message(friendId), newData)
}
